export const SELECTED_BTN_BGCOLOR = "black";
export const UNSELECTED_BTN_BGCOLOR = "lightgrey";

export const SELECTED_BTN_TXTCOLOR = "white";
export const UNSELECTED_BTN_TXTCOLOR = "black";
